import React from 'react'
import { JobWizardMobile } from 'sprockets_react/job_wizards/registries'

JobWizardMobile.JobPostingForm = function({stepComponent}) {
  return(
    <form id="job_form">
        { stepComponent }
    </form>
  )
}
